var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMikeoff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 95.3404V80.1667H53V95.3404H47Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.5833 99H30V93H69.5833V99Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 1C33.268 1 27 7.26801 27 15V16.5856L70.8588 60.4445C72.2153 58.2881 73 55.7357 73 53V15C73 7.26801 66.732 1 59 1H41ZM68.2589 63.5014L27 22.2425V53C27 60.732 33.268 67 41 67H59C62.5498 67 65.7911 65.6788 68.2589 63.5014Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8476 72.4332C85.0631 68.6083 87 63.6727 87 58.2847V37.2847H81V58.2847C81 62.0152 79.7233 65.4475 77.5829 68.1686L81.8476 72.4332ZM74.7383 70.9808C72.0409 73.0529 68.6643 74.2847 65 74.2847H35C26.1634 74.2847 19 67.1212 19 58.2847V37.2847H13V58.2847C13 70.4349 22.8497 80.2847 35 80.2847H65C70.322 80.2847 75.2026 78.3949 79.0074 75.2499L74.7383 70.9808Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.9239 99.6309L1 7.70703L6.65685 2.05018L98.5807 93.9741L92.9239 99.6309Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMikeoff);
export default __webpack_public_path__ + "static/media/mikeoff.6a7c95a9e752f101ee88bc7b19073efb.svg";
export { ForwardRef as ReactComponent };